import React, { MouseEventHandler, Suspense, useState } from 'react';

import CompanyViewCardRatingTable from 'components/company-view/company-view-card/rating/rating-table';
import CompanyViewCardRatingChart from 'components/company-view/company-view-card/rating/chart/chart';
import LoadingOverlay from 'atomic/loading-overlay';
import Link from 'atomic/link/link';

import './rating.scss';
import { CompanyInterface } from 'interfaces/company.interface';

interface CompanyViewCardRatingProps {
    company: CompanyInterface;
    description?: string;
}

const CompanyViewCartRatingModal = React.lazy(() => import('components/company-view/company-view-card/rating/modal/modal'));

const CompanyViewCardRating: React.FC<CompanyViewCardRatingProps> = ({ company, description }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick: MouseEventHandler = e => {
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <div className="company-view-card__rating">
            <div className="company-view-card__rating-container">
                <CompanyViewCardRatingTable/>
                <CompanyViewCardRatingChart/>
            </div>
            <p className="company-view-card__rating-paragraph">
                Podmiot opiniowany mógł w toku procesu OpiConnect rozwiązać problem opiniującego użytkownika. Pozytywne
                rozstrzygnięcie (uwzględnienie reklamacji, uzyskana korzyść – np. otrzymany rabat, rekompensata,
                wyjaśnienie wątpliwości użytkownika) mogło być przyczyną wycofania opinii przez opiniującego.
                {' '}
                <Link href="#" className="company-view-card__rating-link" onClick={handleClick}>
                    Dowiedz się więcej
                </Link>
                .
            </p>
            {description && (
                <div className="company-view-card__opineo-description">
                    <h2 className="company-view-card__opineo-header">
                        {company.name}
                        {' '}
                        - o
                        {' '}
                        {company.type === 'shop' ? 'sklepie' : 'firmie'}
                    </h2>
                    <div className="company-view-card__opineo-text" dangerouslySetInnerHTML={{ __html: description }}/>
                </div>
            )}

            {showModal && (
                <Suspense fallback={<LoadingOverlay/>}>
                    <CompanyViewCartRatingModal onClose={(): void => setShowModal(false)}/>
                </Suspense>
            )}
        </div>
    );
};

export default CompanyViewCardRating;
